import { render, staticRenderFns } from "./stop-game.vue?vue&type=template&id=4344a6ba&scoped=true&"
import script from "./stop-game.vue?vue&type=script&lang=js&"
export * from "./stop-game.vue?vue&type=script&lang=js&"
import style0 from "./stop-game.vue?vue&type=style&index=0&id=4344a6ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4344a6ba",
  null
  
)

export default component.exports